import React from "react";
import {
  Button,
  Col,
  Container,
  FormControl,
  FormLabel,
  Row,
} from "react-bootstrap";
import {
  DepositSearchCriteria,
  PageListBean,
  RestDepositBeanRequest,
} from "../ds/ds.js";
import { LookupHandler, LookupResultDetails } from "../ds/lookup_ds.js";
import { Eraser, TickIcon } from "../gui_components/Icons.js";
import {
  DatePickerComponent,
  InputTextbox,
  ShowError,
} from "../gui_components/UIComponents.js";
import { isEmptyString } from "../gui_components/Util.js";
import { ModuleUtils } from "../modules/ModuleUtils.js";
import { AccountPayableService } from "../services/AccountPayableService.js";
export class DepositLookupHandler extends LookupHandler {
  constructor(companyCode, attribute_name) {
    super();
    this.attribute_name = attribute_name;
    this.lookupTitle = attribute_name + " Lookup";
    this.companyCode = companyCode;
    let resetCriteria = new DepositSearchCriteria();
    resetCriteria.companyCode = companyCode;
    this.resetCriteria = resetCriteria;
    let newCriteria = new DepositSearchCriteria();
    newCriteria.companyCode = companyCode;
    this.newCriteria = newCriteria;
    let depositLookupCriteria = new DepositSearchCriteria();
    depositLookupCriteria.companyCode = this.companyCode;
    let lookupCriteriaView = DepositLookupCriteraHandler(
      companyCode,
      depositLookupCriteria
    );
    let lookupDataCallback = function (
      lookup_dialog,
      page_number,
      searchCriteria,
      filterText
    ) {
      this.fetchDataFromService(
        lookup_dialog,
        page_number,
        searchCriteria,
        filterText
      );
    };
    this.setDetails(
      lookupDataCallback,
      depositLookupCriteria,
      lookupCriteriaView
    );
    ModuleUtils.getDepositStatusList();
    this.initColumns();
  }
  initColumns() {
    this.addColumnDefinition(this.attribute_name, "depositNumber", 0, true); //1
    this.addColumnDefinition("BankCode", "bankCode", 0, false); //2
    this.addColumnDefinition("PaymentType", "paymentTypesName", 0, false); //3
    this.addColumnDefinition("Status", "status", 0, false);
  }
  loadDepositList = (lookup_dialog, pageNumber, searchCriteria) => {
    let deposit_criteria = new DepositSearchCriteria(); //To be fetched from CriteriaHandler
    deposit_criteria.companyCode = this.companyCode;
    if (searchCriteria !== undefined && searchCriteria !== null) {
      deposit_criteria.depositNumberContains =
        searchCriteria.depositNumberContains;
      deposit_criteria.depositNumberStartsWith =
        searchCriteria.depositNumberStartsWith;
      deposit_criteria.bankCode = searchCriteria.bankCode;
      deposit_criteria.depositDate = searchCriteria.depositDate;
      deposit_criteria.status = searchCriteria.status;
    }
    let deposit_pageList = new PageListBean();
    deposit_pageList.pageSize = 50; //TODO --> Fetch from Config
    deposit_pageList.currentPage = pageNumber;
    deposit_pageList.pageNumber = pageNumber;
    let deposit_requestInput = new RestDepositBeanRequest();
    deposit_requestInput.pageInput = deposit_pageList;
    deposit_requestInput.searchCriteria = deposit_criteria;
    AccountPayableService.getDepositPageList(
      deposit_requestInput,
      (response) => this.loadDepositListResponse(response, lookup_dialog),
      this.loadDepositListError
    );
  };
  loadDepositListResponse = (response, lookup_dialog) => {
    let depositList = [];
    let totalCount = 0;
    let currentPageNumber = 0;
    let pageSize = 0;
    if (
      response.data.depositPageList != null &&
      response.data.depositPageList.deposits !== null
    ) {
      depositList = response.data.depositPageList.deposits;
      totalCount = response.data.depositPageList.totalCount;
      currentPageNumber = response.data.depositPageList.currentPage;
      pageSize = response.data.depositPageList.pageSize;
      depositList.map((dt) => {
        dt.status = ModuleUtils.getDepositStatusCaption(dt.status);
      });
    }
    let lookup_result_details = new LookupResultDetails();
    lookup_result_details.pageData = depositList;
    let total_count = 0;
    if (this.lookup_data != null) {
      total_count = this.lookup_data.length;
    }
    lookup_result_details.totalRecordsCount = totalCount;
    lookup_result_details.currentPageNumber = currentPageNumber;
    lookup_result_details.pageSize = pageSize;
    lookup_result_details.criteriaDisplayString = ""; //TODO
    lookup_dialog.updateResultCallBack(lookup_result_details);
  };
  loadDepositListError = (error) => {
    ShowError("Error : " + error);
  };
  fetchDataFromService(lookup_dialog, pageNumber, searchCriteria, filterText) {
    let search = { ...searchCriteria };
    if (search != null && search != "unDefined") {
      // if (isEmptyString(search.depositNumberContains)) {
      if (!isEmptyString(filterText)) {
        search.depositNumberContains = filterText;
        this.searchCriteria = new DepositSearchCriteria();
      }
    }
    if (lookup_dialog != null) {
      this.loadDepositList(lookup_dialog, pageNumber, search);
    }
  }
}
const DepositLookupCriteraHandler = (companyCode, depositLookupCriteria) => {
  return class extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        searchCriteria: new DepositSearchCriteria(),
      };
      this.criteriaLookupHandler = React.createRef();
      this.focusRef = React.createRef();
    }
    componentDidMount() {
      let searchCriteria = this.state.searchCriteria;
      searchCriteria.companyCode = companyCode;
      this.setState({ searchCriteria: searchCriteria });
      if (this.focusRef.current) this.focusRef.current.focus();
    }
    continueButtonClick = () => {
      this.props.searchCriteriaCallBack(this.state.searchCriteria);
    };
    onChange = (e) => {
      let temp_searchCriteria = this.state.searchCriteria;
      temp_searchCriteria[e.target.name] = e.target.value;
      this.setState({ searchCriteria: temp_searchCriteria });
    };
    clearCriteria = () => {
      let searchCriteria = new DepositSearchCriteria();
      searchCriteria.companyCode = companyCode;
      this.setState({ searchCriteria: searchCriteria });
      if (this.focusRef.current) this.focusRef.current.focus();
    };
    onContainerKeyDown = (e) => {
      if (e.ctrlKey && e.keyCode == "191") {
        this.continueButtonClick();
      }
    };
    render() {
      let searchCriteria = this.state.searchCriteria;
      return (
        <div>
          <Container onKeyDown={this.onContainerKeyDown}>
            <Row>
              <Col sm={5}>
                <FormLabel>Deposit Number Starts With</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="depositNumberStartsWith"
                  name="depositNumberStartsWith"
                  onChange={this.onChange}
                  value={searchCriteria.depositNumberStartsWith}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>Deposit Number Contains</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="depositNumberContains"
                  name="depositNumberContains"
                  onChange={this.onChange}
                  value={searchCriteria.depositNumberContains}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>Bank Code</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="bankCode"
                  name="bankCode"
                  onChange={this.onChange}
                  value={searchCriteria.bankCode}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>Deposit Date</FormLabel>
              </Col>
              <Col sm={7}>
                <DatePickerComponent
                  //tabIndex={-1}
                  id="depositDate"
                  name="depositDate"
                  onChange={this.onChange}
                  value={searchCriteria.depositDate}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>Status</FormLabel>
              </Col>
              <Col sm={7}>
                <FormControl
                  as="select"
                  custom
                  onChange={this.onChange}
                  name="status"
                  value={searchCriteria.status}
                >
                  <option value={""}></option>
                  <option value={"O"}>Open</option>
                  <option value={"A"}>Approved</option>
                </FormControl>
              </Col>
              {/* <Row>
            <Col sm={5}>
                <FormLabel>Deposit Date</FormLabel>
              </Col>
              <Col sm={4}>
                <DatePickerComponent
                  //tabIndex={-1}
                  id="depositDate"
                  name="depositDate"
                  onChange={this.onChange}
                  value={searchCriteria.depositDate}
                />
              </Col>
              </Row> */}
            </Row>
            <Row className="popup_criteria_button_align-lookup">
              <Button
                className="header_buttons btn btn-primary btn-sm enterFocus"
                onClick={this.continueButtonClick}
                ref={this.focusRef}
              >
                <TickIcon />
                Continue
              </Button>
              <Button
                className="header_buttons btn btn-primary btn-sm enterFocus"
                onClick={this.clearCriteria}
              >
                <Eraser />
                Clear
              </Button>
            </Row>
          </Container>
        </div>
      );
    }
  };
};
